/**
 * The title's letters as the physics and the layout see them: boxes measured in the DOM, the
 * viewport that maps them to world units, and the "pegs" (vertical stems a falling ring can
 * hook onto, like the posts of a water ring-toss toy) the title model defines.
 */

import titleModel from './titleModel.json' with { type: 'json' }

/** One letter of the title as measured in the DOM, in CSS pixels relative to the canvas. */
export interface LetterBox {
  char: string
  x: number
  y: number
  width: number
  height: number
  /** Current `wght` axis value (100–1000). */
  weight: number
}

/** Canvas size in pixels and the size of the world it shows at z = 0. */
export interface Viewport {
  width: number
  height: number
  wWidth: number
  wHeight: number
}

// The title's face in inline-block spans at line-height 1: where the baseline and the cap top
// sit in the line box, from the font's own metrics (scripts/build-title-model.ts writes them).
export const CAP_TOP: number = titleModel.metrics.capTop
export const BASELINE: number = titleModel.metrics.baseline

/** A vertical stem a ring can thread onto. World units, y up. */
export interface Peg {
  x: number
  /** Top of the stem; a ring hooks when its centre falls past this line. */
  top: number
  /** Where the lowest ring comes to rest (its tube touches this line). */
  rest: number
  /** Half thickness at the tip. */
  halfWidth: number
}
